import React from "react"
import "../index.less"

import { Button } from "antd"

import emptyDashboard from "images/empty-dashboard.svg"
import leftArrowSvg from "images/left-arrow.svg"
import {
  isAmbassadorActive,
  isAmbassadorOrLeaderActive,
} from "../../../utils/storage"
import { loadTexts, sanitize } from "../../../utils/i18n"

const DashboardEmptyState = (props) => {
  const intl = loadTexts("reports_dashboard")
  const onMeasureClick = () => {
    const { history } = props
    history.push(`/models/measure-history`)
  }
  const isEmbedded = window.top !== window.self;
  return (
    <div className="empty-dashboard">
      <img
        src={emptyDashboard}
        alt="empty-dashboard"
        className="empty-dashboard-img"
      />
      <div className="empty-dashboard-title">
        {intl.dashboard.dashboardEmptyState.title}
      </div>
      <div className="empty-dashboard-description">
        {sanitize(intl.dashboard.dashboardEmptyState.description)}
      </div>
      {(!isAmbassadorOrLeaderActive() && !isEmbedded) && (
        <Button
          onClick={() => onMeasureClick()}
          className="empty-dashboard-button">
          <img src={leftArrowSvg} />
          {intl.dashboard.dashboardEmptyState.button}
        </Button>
      )}
    </div>
  )
}

export default DashboardEmptyState
